export enum LINK_TYPES {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  AI_CONNECTED = 'ai',
}

export enum LINK_SIZES {
  MEDIUM = 'md',
  LARGE = 'lg',
  SMALL = 'sm',
}

export enum LINK_TARGETS {
  BLANK = '_blank',
  SELF = '_self',
  PARENT = '_parent',
  TOP = '_top',
}

export enum LINK_VARIANTS {
  INLINE = 'inline',
  STANDALONE = 'standalone',
}
